import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import FileSaver from 'file-saver';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputAdornment,
  TextField,
} from '@mui/material';
import {DialogTitle} from '@apps-common/ui-components';

const FILE_EXTENSION = '.geojson';

export const DownloadAoiDialog = props => {
  const {t} = useTranslation();
  const [filename, setFilename] = useState('explorer-aoi');

  return (
    <Dialog
      open
      fullWidth
      onClose={props.onClose}
      data-testid="download-aoi-dialog"
    >
      <DialogTitle
        title={props.title || t('downloadAOI.title', 'Download AOI')}
        subheader={
          props.subtitle ||
          t(
            'downloadAOI.subtitle',
            'Areas of interest will be downloaded as a GeoJSON'
          )
        }
        onClose={props.onClose}
      />
      <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          margin="dense"
          label={t('downloadAOI.fileNameLabel', 'Filename')}
          value={filename}
          onChange={evt => setFilename(evt.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{FILE_EXTENSION}</InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          disabled={!filename}
          data-testid="download-aoi-button"
          onClick={() => {
            const collection = JSON.stringify({
              type: 'FeatureCollection',
              features: [props.aoi],
            });
            const blob = new Blob([collection], {
              type: 'text/plain;charset=utf-8',
            });
            FileSaver.saveAs(blob, `${filename}${FILE_EXTENSION}`);
            props.onClose();
          }}
        >
          {t('downloadAOI.downloadButton', 'Download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DownloadAoiDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  aoi: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default DownloadAoiDialog;
